(() => {
  if (window.ihPurchaseGuidanceInitialized) return;
  window.ihPurchaseGuidanceInitialized = true;
  const normalize = value => String(value || '').toLowerCase().replace(/\bpair\b/g, '').trim().replace(/\s+/g, ' ');
  const read = element => { try { return JSON.parse(element?.textContent || 'null'); } catch (_) { return null; } };
  const selectedFinish = variant => {
    const picker = document.querySelector('product-info variant-selects');
    const names = read(document.querySelector('[data-guidance-option-names]')) || [];
    const index = names.findIndex(name => /finish/i.test(name));
    const current = variant || read(picker?.querySelector('[data-selected-variant]'));
    return index < 0 ? '' : current?.options?.[index] || '';
  };
  const update = variant => {
    const finish = selectedFinish(variant);
    document.querySelectorAll('[data-coordinate-variants]').forEach(script => {
      const data = read(script), card = script.closest('li');
      if (!data || !card) return;
      const matches = data.variants.filter(v => finish && normalize(v.finish) === normalize(finish));
      const match = matches.find(v => v.available) || matches[0];
      card.dataset.finishMatch = match ? 'exact' : 'complementary';
      card.classList.add('product-coordinate-card');
      // RECOMMENDATION_NATIVE_PRICE_ONLY: keep metadata inside the native card.
      card.querySelectorAll('[data-coordinate-note], [data-coordinate-price]').forEach(node => node.remove());
      card.querySelectorAll('.price, .family-review-price').forEach(node => { node.hidden = false; });
      card.querySelectorAll('a[href]').forEach(a => {
        if (!a.getAttribute('href').includes('/products/')) return;
        a.href = match ? `${data.url}?variant=${match.id}` : data.url;
        a.dataset.ihFeature = 'product-coordination';
        a.dataset.ihResource = match ? 'matching-finish' : 'complementary-finish';
      });
      card.querySelectorAll('img').forEach((img, index) => {
        if (!img.dataset.originalSrc) { img.dataset.originalSrc = img.getAttribute('src') || ''; img.dataset.originalSrcset = img.getAttribute('srcset') || ''; img.dataset.originalAlt = img.alt; }
        if (match?.image) {
          img.hidden = index > 0;
          if (!index) { img.src = match.image; img.removeAttribute('srcset'); img.alt = `${data.title} — ${match.finish}`; }
        } else {
          img.hidden = !!match;
          if (!match) { img.src = img.dataset.originalSrc; if (img.dataset.originalSrcset) img.srcset = img.dataset.originalSrcset; img.alt = img.dataset.originalAlt; }
        }
      });
    });
    document.querySelectorAll('.paired-products__grid').forEach(grid => {
      [...grid.children].sort((a,b) => Number(b.dataset.finishMatch === 'exact') - Number(a.dataset.finishMatch === 'exact')).forEach(card => grid.append(card));
    });
  };
  const observedRecommendations = new WeakSet();
  const initialize = () => {
    update();
    document.querySelectorAll('product-recommendations.paired-products').forEach(container => {
      if (observedRecommendations.has(container)) return;
      observedRecommendations.add(container);
      new MutationObserver(() => {
        update();
        document.dispatchEvent(new CustomEvent('product-info:loaded'));
      }).observe(container, {childList:true});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true}); else initialize();
  document.addEventListener('product-info:loaded', initialize);
  document.addEventListener('shopify:section:load', initialize);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => update(data.variant));
  }
})();
